<div class="clickable-bar">
  <div
    class="bar-segment"
    [ngClass]="{ popBar: seg.order == selectedSeg }"
    *ngFor="let seg of data"
    (click)="toggleSeg(seg)"
    [ngStyle]="{ 'background-color': seg.color, width: seg.y + '%' }"
    [tooltip]="clickableBarTooltip"
    [placement]="last ? 'left' : 'top'"
    container="body"
  >
    <p *ngIf="seg.y > 40">{{ seg.y }}{{ suffix }}</p>
    <ng-template #clickableBarTooltip>
      <clickable-bar-tooltip
        [y]="seg.y"
        [name]="seg.name"
        [color]="seg.color"
        [prefix]="prefix"
        [suffix]="suffix"
        [numerator]="seg.numerator"
        [descriptor]="seg.definition"
        [denominator]="seg.denominator"
        [subtitle]="overallSubtitle"
      ></clickable-bar-tooltip>
    </ng-template>
  </div>
</div>
